import FavoriteLinks from './FavoriteLinks';

export default FavoriteLinks;
